
/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .service('SwapInstallationService', SwapInstallationService);

    /**
     * @constructor
     * @ngInject
     */
    function SwapInstallationService(InstallationsService, ApiService, $stateParams) {

        /* Public API */
        var service = {
            swapInstallationsModel: {
                currentInstallation: null,
                selectedInstallation: null,
                rawInstallations: null
            },
            initModel: initModel,
            setCurrentInstallation: setCurrentInstallation,
            setSelectedInstallation: setSelectedInstallation,
            clearSelected: clearSelected
        };

        return service;

        function clearSelected() {
            service.swapInstallationsModel.currentInstallation = null;
            service.swapInstallationsModel.selectedInstallation = null;
        }

        async function initModel() {
            await loadInstallations();
            setCurrentInstallation($stateParams.id);
        }

        async function loadInstallations() {
            await InstallationsService.loading
            const installations = await InstallationsService.installations;
            const gateways = await loadGateways();

            if (installations && gateways) {
                service.swapInstallationsModel.rawInstallations = mergeGateways(gateways.records, installations);
            }
        }

        async function loadGateways() {
            const gateways = await getGatewaysByUser();
            return gateways;
        }

        async function getGatewaysByUser() {
            return ApiService.users('cerbo-gx-data').then(function (response) {
                if (response && response.data && !response.data.success) {
                } else {
                    return response.data;
                }
            }, function () {
                return false;
            });
        }

        async function setCurrentInstallation(idSite) {
            await loadInstallations();
            service.swapInstallationsModel.currentInstallation = findInstallationObject(idSite);
        }

        async function setSelectedInstallation(idSite) {
            await loadInstallations();
            service.swapInstallationsModel.selectedInstallation = findInstallationObject(idSite);
        }

        function findInstallationObject(idSite) {
            const installation = service.swapInstallationsModel.rawInstallations.find((installation) =>{
                return String(installation.idSite) === String(idSite)
            })
            return installation;
        }

        function mergeGateways(gateways, installations) {
            let merged = [];
            Object.values(gateways).forEach((gateway) => {
                if (gateway.idSite) {
                    const item = Object.values(installations).find(installation => {
                        return String(installation.idSite) === String(gateway.idSite)
                    })
                    item['gateway'] = gateway
                    merged.push(item);
                }
            })
            return merged;
        }
    }
})();